import React from "react";

import {
  GiLaurelsTrophy,
  GiSevenPointedStar,
  GiTwoCoins,
} from "react-icons/gi";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { AiOutlinePlusCircle } from "react-icons/ai";

import { useApp } from "../../../contexts";
import { paletas } from "../../../styles/theme";
import { Wrapper, Icone, Progress, Mensagem } from "./styles";
import { IUsuarios } from "../../../models";
import { CarregarDadosUsuario } from "../../../servicos";

export default function StatusDev() {
  const { usuario, setUsuarioCorrente } = useApp();
  const [abrirModal, setAbrirModal] = React.useState(false);
  const [dadosUsuario, setDadosUsuario] = React.useState<IUsuarios>();
  const [level, setLevel] = React.useState(0);
  const [experiencia, setExperiencia] = React.useState(0);

  const carregarDadosUsuario = React.useCallback(async () => {
    if (usuario.email) {
      try {
        let dados = await CarregarDadosUsuario(usuario.email);
        setDadosUsuario(dados);
        setLevel(dados.player_statistics.level);
        setExperiencia(dados.player_statistics.experience);
      } catch (err) {
        console.error("Erro ao carregar dados do usuário! ", err);
      }
    }
  }, [usuario.email]);

  React.useEffect(() => {
    carregarDadosUsuario();
  }, [carregarDadosUsuario, setUsuarioCorrente]);

  const barraExperiencia = React.useMemo(() => {
    let chequeLevel =
      dadosUsuario && dadosUsuario.player_statistics.level > level;
    if (level !== 0 && chequeLevel) {
      setAbrirModal(true);
    }
    return experiencia - (level - 1) * 100;
  }, [experiencia, level, dadosUsuario]);

  return (
    <Wrapper>
      <Grid
        container
        justify="flex-start"
        alignContent="center"
        alignItems="center"
      >
        <div className="avatar">
          <img src={dadosUsuario?.profile_picture} alt="" />
        </div>

        <Grid item className="conteudo-usuario">
          <Grid container item justify="space-between" className="box">
            <p className="no-mobile">{dadosUsuario?.name}</p>
            <Grid container item justify="space-between" className="secundario">
              <Grid item className="">
                LEVEL
                <span>{level === 99 ? "Max" : level}</span>
              </Grid>
              <Grid item data-tip data-for="pdl" data-iscapture="true">
                <GiSevenPointedStar color={paletas.DarkOrange} />
                <span>{dadosUsuario?.player_statistics?.league_points}</span>
                PDL
              </Grid>
              <Grid item>
                <Link to="/recarga" data-tip data-for="devcoin">
                  <span>
                    <GiTwoCoins color={paletas.DarkOrange} />
                    <span>{dadosUsuario?.devcoin}</span>
                    <Icone>
                      <AiOutlinePlusCircle
                        className="devcoin"
                        color={paletas.GreenMunsell}
                      />
                    </Icone>
                  </span>
                </Link>
              </Grid>
            </Grid>
          </Grid>

          {/* BARRA DE EXPERIENCIA */}
          <Progress valor={barraExperiencia} data-tip data-for="exp" />

          {/* TOOLTIPS */}
          <ReactTooltip id="devcoin" type="dark" place="bottom">
            As <b>DEVCOINS</b> podem ser usadas para acelerar
            <br />
            seu progresso no jogo e participar de torneios!
          </ReactTooltip>
          <ReactTooltip id="pdl" type="dark" place="bottom">
            Os <b>Pontos de ligas</b> são usados para rankear sua posição.
            <br />
            Ganhe PDL's atráves de batalhas e torneios!
          </ReactTooltip>
          <ReactTooltip id="exp" type="dark" place="bottom">
            {experiencia} xp
          </ReactTooltip>
        </Grid>
      </Grid>
      <Mensagem className={abrirModal ? "mostrar" : "fechar"}>
        <div>
          <h2>LEVEL UP!</h2>
          <GiLaurelsTrophy size={80} color={paletas.DarkOrange} />
          <span>{level}</span>
          <p>PARABÉNS, VOCÊ ALCANÇOU UM NOVO NÍVEL!</p>
          <button onClick={() => setAbrirModal(false)}>CONTINUE</button>
        </div>
      </Mensagem>
    </Wrapper>
  );
}
